import React, { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import SectionTitle from "../SectionTitle/SectionTitle";
import Services from "../../api/Services";



const ServiceSection = (props) => {
    const { hclass, showSectionTitle = true, showGrid = false } = props;
    const sliderRef = useRef(null);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    // Smooth auto-scroll for horizontal slider
    useEffect(() => {
        if (showGrid) return;

        const slider = sliderRef.current;
        if (!slider) return;

        let frameId;
        const speed = 0.8;

        const startAnimation = () => {
            const step = () => {
                if (!slider) return;

                const halfWidth = slider.scrollWidth / 2;
                slider.scrollLeft += speed;

                if (slider.scrollLeft >= halfWidth) {
                    slider.scrollLeft = slider.scrollLeft - halfWidth;
                }

                frameId = requestAnimationFrame(step);
            };

            frameId = requestAnimationFrame(step);
        };

        const timer = setTimeout(startAnimation, 100);

        return () => {
            clearTimeout(timer);
            cancelAnimationFrame(frameId);
        };
    }, [showGrid]);

    return (
        <section className={hclass}>
            <div className={showGrid ? "container-fluid service-grid-container" : "container-fluid"}>

                {showSectionTitle && (
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-12">
                            <SectionTitle title={"Departmental Services"} subtitle={"Our Medical Services"} />
                        </div>
                    </div>
                )}

                {showGrid ? (
                    /* ── Grid layout for /services page ── */
                    <div className="row service-grid">
                        {Services.map((servic, index) => (
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12" key={index}>
                                <div className="service_card">
                                    <div className="icon">
                                        <i className={servic.icon}></i>
                                    </div>
                                    <div className="content">
                                        <h2>{servic.title}</h2>
                                        <p>{servic.description}</p>
                                        {/* <Link onClick={ClickHandler} to={`/service-single/${servic.slug}`}>
                                            <i className="flaticon-right-arrow"></i>
                                        </Link> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    /* ── Auto-scrolling slider for homepage ── */
                    <>
                        <div className="service-slider-wrapper">
                            <div className="service-slider" ref={sliderRef}>
                                {[...Services, ...Services].map((servic, index) => (
                                    <div className="service-slide" key={index}>
                                        <div className="service_card">
                                            <div className="icon">
                                                <i className={servic.icon}></i>
                                            </div>
                                            <div className="content">
                                                <h2>{servic.title}</h2>
                                                <p>{servic.description}</p>
                                                {/* <Link onClick={ClickHandler} to={`/service-single/${servic.slug}`}>
                                                    <i className="flaticon-right-arrow"></i>
                                                </Link> */}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="btn">
                                    <Link onClick={ClickHandler} to={"/services"} className="theme-btn">
                                        See All Services
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </div>
        </section>
    );
};

export default ServiceSection;
